<template>
  <div class="leave-temp">
    <basiCcontainer>
      <template>
        <commonTable
          tableHead="leave"
          :apiUrl="{ url:'staffManagement', methods:'getStaffIndex' }"
          ref="commonTable"
          :params="ruleForm"
          :tipShow="false"
        >
          <template #table_head>
            <div class="leave-temp-header">
              离职管理
            </div>
            <div class="search-table">
              <div class="search-table-tool">
                <el-input
                  prefix-icon="iconfont iconicon_search1"
                  @input="searchChange"
                  class="fliter-input"
                  v-model="ruleForm.keyword"
                  size="mini"
                  placeholder="搜索员工名称/工号/手机号/邮箱"
                  clearable
                  @keyup.enter.native="searchChange"
                ></el-input>
              </div>
            </div>
          </template>
          <template slot="depart_id" slot-scope="scope">
            <span>{{scope.data.department ? scope.data.department.name : '-' }}</span>
          </template>
          <template slot="usertype" slot-scope="scope">
            <span>{{typeList[scope.data.usertype]}}</span>
          </template>
          <template slot="is_secret" slot-scope="scope">
            <span>{{scope.data.is_secret > 0 ? '是' : '否'}}</span>
          </template>
          <template slot="job" slot-scope="scope">
            <span>{{scope.data.job ? scope.data.job.job_name : '-'}}</span>
          </template>
          <template slot="realname" slot-scope="scope">
            <div class="real-name-style" @click="satffDetail(scope.data)">
              <Myavatar :userName="scope.data.realname" width="28px" height="28px" :imgUrl="scope.data.user_avatar">{{scope.data.realname}}</Myavatar>
            </div>
          </template>
        </commonTable>
      </template>
    </basiCcontainer>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      ruleForm: {
        keyword: '',
        departments_id: '',
        working_type: '',
        working_status: '离职'
      },
      timer: '',
      selectDeparVisible: false
    }
  },
  mounted() {
    this.$refs.commonTable.getTableList()
  },
  methods: {
    searchChange() {
      clearInterval(this.timer)
      this.timer = ''
      this.timer = setInterval(() => {
        this.$refs.commonTable.getTableList()
        clearInterval(this.timer)
        this.timer = ''
      }, 300)
    }
  }
}
</script>
<style lang="scss" src="./style.scss">
</style>
